var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"header-banner"},[_c('div',{staticClass:"header-center"},[_vm._v(_vm._s(_vm.$t('banner.title')))]),_c('div',{staticClass:"header-right"},[_c('div',{staticClass:"icon",on:{"click":_vm.onSearch}},[_vm._v("🔍")]),_c('div',{staticClass:"icon",on:{"click":_vm.onMore}},[_vm._v("⋮")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }